/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Page_TitleInputs */

const vi_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xảy ra lỗi`)
};

/**

* @param {Error_Page_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_page_title = /** @type {((inputs?: Error_Page_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Page_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_page_title(inputs)
});